var _polyline, _rect, _animateTransform;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUnreadMailSvgrepoCom = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
  id: "Complete"
}, /*#__PURE__*/React.createElement("g", {
  id: "mail"
}, /*#__PURE__*/React.createElement("g", null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  points: "4 8.2 12 14.1 20 8.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  height: 14,
  rx: 2,
  ry: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  width: 18,
  x: 3,
  y: 6.5
})), /*#__PURE__*/React.createElement("circle", {
  id: "secondary",
  cx: 0,
  cy: 0,
  r: 3.5,
  style: {
    fill: "#ff0000",
    strokeWidth: 0
  },
  transform: "translate(20.5, 6.5)"
}, _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
  id: "anim1",
  attributeName: "transform",
  additive: "sum",
  begin: "0s; anim2.end",
  dur: "3s",
  type: "scale",
  values: "1;.7;1",
  repeatCount: "indefinite"
})))))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUnreadMailSvgrepoCom, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/unread-mail-svgrepo-com.858773af.svg";
export { ForwardRef as ReactComponent };